export const isReady = state => state.videoLibrary.isReady
export const isTopCategoriesReady = state =>
  state.videoLibrary.isTopCategoriesReady
export const hasError = state => state.videoLibrary.hasError === true
export const getErrorMessage = state => state.videoLibrary.errorMessage
export const getPopularVideos = state =>
  state.videoLibrary.popularVideos.map(id => state.videoLibrary.byId[id])
export const getRecentVideos = state =>
  state.videoLibrary.recentVideos.map(id => state.videoLibrary.byId[id])
export const getTopCategories = state => state.videoLibrary.topCategories
export const getFocusedSection = state => state.videoLibrary.focusedSection
export const getFocusedPosition = state => state.videoLibrary.focusedPosition
export const getMoreVideos = state => {
  const moreVideos = {}
  for (const section in state.videoLibrary.moreVideos) {
    moreVideos[section] = state.videoLibrary.moreVideos[section].map(
      id => state.videoLibrary.byId[id]
    )
  }
  return moreVideos
}
export const getOverviewItem = state => {
  if (state.videoLibrary.overview.type === 'video') {
    if (
      state.videoLibrary.overview.id > 0 &&
      typeof state.videoLibrary.byId[state.videoLibrary.overview.id] !==
        'undefined'
    ) {
      return {
        type: 'video',
        item: state.videoLibrary.byId[state.videoLibrary.overview.id]
      }
    }
  } else if (state.videoLibrary.overview.type === 'category') {
    if (
      typeof state.videoLibrary.topCategories[
        state.videoLibrary.overview.id
      ] !== 'undefined'
    ) {
      return {
        type: 'category',
        item: state.videoLibrary.topCategories[state.videoLibrary.overview.id]
      }
    }
  }
  return {
    type: 'unknown',
    item: null
  }
}
